import React, { Component } from 'react'
/*
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

import NativeSelect from '@material-ui/core/NativeSelect';
*/

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

class DropdownCP extends Component {
  constructor(props) {
    super(props)
    /*
    this.state = {
      value: this.props.value || ""
    }
    */
  }

  // componentDidMount() {}

  render() {
    var isEditable = true // default to true
    if ('isEditable' in this.props) isEditable = this.props.isEditable
    isEditable = isEditable && this.props.meta.displayEditable
    return (
      <Select {...this.props.meta.markupAttributes}
              className="bcioInput muiOverride" 
              name={this.props.objPath}
              value={this.props.value || ''} 
              disabled={!isEditable} 
              onChange={(event => this._onChange(event))} 
      >
        <MenuItem aria-label="None" value=""></MenuItem>
        {
          this.renderOptions(this.props.meta.displayTypeProps.enums)
        }
      </Select>
    )
  }

  renderOptions(items) {
    var optionsEles = []
    items.forEach(item => {
      optionsEles.push(this.renderOption(item))
    })
    return optionsEles
  }

  renderOption(item) {
    return (
      <MenuItem key={item.value} value={item.value}>
        <div className='bcioInputCircle'>
          <div className='bcioCheckmark'></div>
        </div>
        {item.label}
      </MenuItem>
    )
  }

  _onChange(event) {
    //this.setState({value: event.target.value})
    this.props.onChange(event, event.target.value, this.props.objPath)
  } 
}

export default DropdownCP
